<template>
  <div
    class="Fuell-Table"
    style="overflow-x: auto"
    ref="table"
  >
    <div
      :style="tableGridTemplateStyle"
      class="Fuell-Table--header"
    >
      <div class="Fuell-Table--item ">
        <span
          v-t="{path: 'benefits_users_table_header_employee'}"
          v-tooltip="$t('benefits_users_table_header_employee')"
        ></span>
      </div>
      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('subvention_status')"
      >
        <span
          v-t="{path: 'benefits_users_table_header_subvention_status'}"
          v-tooltip="$t('benefits_users_table_header_subvention_status')"
        ></span>
      </div>

      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('restaurants_current_assigned')"
      >
        <span v-tooltip="$t('benefits_users_table_header_meals_current_month', {currentMonth: currentMonth})"> {{$t('benefits_users_table_header_meals_current_month', {currentMonth: currentMonth})}}</span>
      </div>
      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('restaurants_next_month_assigned')"
      >
        <span v-tooltip="$t('benefits_users_table_header_meals_next_months')"> {{$t('benefits_users_table_header_meals_next_months')}}</span>
      </div>
      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('restaurants_spent_vs_available')"
      >
        <span
          v-tooltip="$t('benefits_users_table_header_spent_vs_available')"
          v-t="{path: 'benefits_users_table_header_spent_vs_available'}"
        ></span>
      </div>

      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('transport_current_assigned')"
      >
        <span v-tooltip="$t('benefits_users_table_header_transport_current_month', {currentMonth: currentMonth})">
          {{$t('benefits_users_table_header_transport_current_month', {currentMonth: currentMonth})}}
        </span>
      </div>
      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('transport_next_month_assigned')"
      >
        <span v-tooltip="$t('benefits_users_table_header_transport_next_months')">{{$t('benefits_users_table_header_transport_next_months')}}</span>
      </div>

      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('transport_spent_vs_available')"
      >
        <span
          v-tooltip="$t('benefits_users_table_header_spent_vs_available')"
          v-t="{path: 'benefits_users_table_header_spent_vs_available'}"
        ></span>
      </div>

      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('nursery_current_assigned')"
      >
        <span
          v-tooltip="$t('benefits_users_table_header_nursery_assignation')"
          v-t="{path:'benefits_users_table_header_nursery_assignation'}"
        >
        </span>
      </div>

      <div
        class="Fuell-Table--item"
        v-tooltip="$t('benefits_users_table_header_insurance_assignation')"
        v-if="isColumnVisible('insurance_current_assigned')"
      >
        <span>
          {{$t('benefits_users_table_header_insurance_assignation')}}
        </span>
      </div>
      <div
        class="Fuell-Table--item"
        v-tooltip="$t('benefits_users_table_header_insurance_policy_holders')"
        v-if="isColumnVisible('insurance_policy_holder')"
      >
        <span>
          {{$t('benefits_users_table_header_insurance_disabled_policy_holders')}}
        </span>
      </div>
      <div
        class="Fuell-Table--item"
        v-if="isColumnVisible('insurance_disabled_policy_holders')"
      >
        <span v-tooltip="$t('benefits_users_table_header_insurance_disabled_policy_holders')">
          {{$t('benefits_users_table_header_insurance_disabled_policy_holders')}}
        </span>
      </div>

      <div
        class="Fuell-Table--item"
        v-tooltip="$t('benefits_users_table_header_insurance_education_assignation')"
        v-if="isColumnVisible('education_current_assigned')"
      >
        <span>
          {{$t('benefits_users_table_header_insurance_education_assignation')}}
        </span>
      </div>

    </div>
    <div class="Fuell-Table--content">
      <users-social-benefits-table-row
        @showRequestGrossSalaryModal="showRequestSalaryModal($event)"
        @showConfirmDeactivationModal="showConfirmDeactivationModal($event)"
        v-for="user in users"
        :user="user"
        :columns="columns"
        :key="user.id"
      ></users-social-benefits-table-row>
    </div>

    <div
      class="Fuell-Table--spinner"
      v-if="isCallingUsers"
    >
      <spinner></spinner>
    </div>
  </div>
</template>

<script>
import UsersSocialBenefitsTableRow from './UserSocialBenefitsTableRow'
import Spinner from '@/components/Commons/Spinner'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'

export default {
  name: 'UsersSocialBenefitsTable',
  components: {
    UsersSocialBenefitsTableRow, Spinner
  },
  props: {
    userId: {
      type: [Number, String],
      default: 0
    },
    columns: {
      type: Array
    }
  },
  mixins: [_paginationHandlerMixin],
  computed: {
    users () {
      // Used when checking on user detail
      if (this.userId) {
        return this.$store.getters['UsersStore/users'].filter(el => el.id === Number.parseInt(this.userId))
      } else {
        return this.$store.getters['UsersStore/users']
      }
    },
    currentPage () {
      return this.$store.getters['UsersStore/currentPage']
    },
    lastPage () {
      return this.$store.getters['UsersStore/lastPage']
    },
    isCallingUsers () {
      return this.$store.getters['UsersStore/isCallingUsers']
    },
    officeConfig () {
      return this.$store.getters['CompanyStore/currentCompany'].configs || false
    },
    currentOffice () {
      return this.$store.getters['CompanyStore/currentCompany'].id || 0
    },
    budgetClosureDates () {
      const closureDateInfo = this.officeConfig.find(el => el.code === 'FLEXIBLE_REMUNERATION_CLOSURE_MONTHS_DATE')
      return closureDateInfo || false
    },

    currentMonth () {
      if (!this.budgetClosureDates) return 'Mes en curso'
      const currentMonth = this.$moment.utc(this.budgetClosureDates.config.currentMonth.flex_rem_closure_date).toDate()
      return this.$i18n.d(currentMonth, 'month_only')
    },
    nextMonth () {
      const nextMonth = this.$moment.utc().add(1, 'month').toDate()
      return this.$i18n.d(nextMonth, 'month_only')
    },
    tableGridTemplateStyle () {
      return {
        gridTemplateColumns: this.columns.filter(c => this.isColumnVisible(c.key)).map(c => c.template).join(' '),
        gridGap: '15px'
      }
    }

  },
  methods: {
    showRequestSalaryModal (event) {
      this.$emit('showRequestSalaryModal', { ...event })
    },
    showConfirmDeactivationModal (event) {
      this.$emit('showConfirmDeactivationModal', event)
    },
    nextPage () {
      this.$store.dispatch('UsersStore/nextUsersPage')
    },
    isColumnVisible (key) {
      const column = this.columns.find(el => el.key === key)
      return column && column.visible
    }

  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/tables/social-benefits-table.scss";
.Fuell-Table--item > span {
  font-size: 1em;
}
</style>
